import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import PredefinedDateRanges from "../../../core/common/datePicker";
import Table from "../../../core/common/dataTable/index";
import { all_routes } from "../../router/all_routes";
import { userreportDetails } from "../../../core/data/json/userreportDetails";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import ReactApexChart from "react-apexcharts";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { getUsers } from "../../../core/data/redux/user/userAction";
import {
  fetchAllusercount,
  fetchAllusercountMonthWise,
  fetchAllUserRoleWise,
} from "../../../core/data/redux/reports/user_report/user.Action";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { fetchAllRoles } from "../../../core/data/redux/user/role/roleAction";
import { table } from "console";
import { exportToCSV, exportToExcel } from "../../../core/common/GlobalFunctions/exportTableData";

interface UserReportProps {
  showOnlyTable?: boolean;
}


const UserReports: React.FC<UserReportProps> = ({showOnlyTable}) => {
  const [tableKey, setTableKey] = useState(0);
  const [roleWiseUsers, setroleWiseUsers] = useState<any>(null);
  const [selectedRoleId, setSelectedRoleId] = useState<number | null>(null);
  const { roles } = useSelector((state: any) => state.role);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
  const [monthcount, setMonthcount] = useState<any[]>([]);
  const { totalUsers } = useSelector((state: any) => state.user);
  const [monthlyCounts, setMonthlyCounts] = useState<number[]>(
    new Array(12).fill(0)
  );
  const [count, setcount] = useState<any>(null);
  const dispatch = useDispatch<AppDispatch>();
  const [selectedYear, setSelectedYear] = useState("2025");

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, totalUsers, roleWiseUsers]);

  useEffect(() => {
    dispatch(fetchAllRoles());
    dispatch(getUsers());
    dispatch(fetchAllusercount()).then((res) => {
      setcount(res.payload.data);
    });
    dispatch(fetchAllusercountMonthWise(selectedYear)).then((res) => {
      const data = res.payload.data;
      setMonthcount(data);
    });
  }, []);

  const handleRoleSelect = (roleId: number) => {
    setSelectedRoleId(roleId);
    dispatch(fetchAllUserRoleWise(roleId)).then((res) => {
      setroleWiseUsers(res.payload.data);
    });
  };

  const handleYearSelect = (year: any) => {
    setSelectedYear(year);
  };

  useEffect(() => {
    if (selectedYear) {
      dispatch(fetchAllusercountMonthWise(selectedYear)).then((res) => {
        const data = res.payload.data;
        setMonthcount(data);
      });
    }
  }, [selectedYear]);

  function filterUserData(data: any[]) {
    return data.map(user => ({
      Username: user.Username || "N/A",
      DisplayName: user.DisplayName || "N/A",
      Email: user.Email || "N/A",
      RoleName: user.RoleName || "N/A",
      MobileNumber: `${user.mobile_code || ""}${user.mobile || ""}`
    }));
  }



  const data = useMemo(() => {
    if (selectedRoleId && roleWiseUsers?.length > 0) {
      return roleWiseUsers;
    }
    return totalUsers;
  }, [selectedRoleId, roleWiseUsers, totalUsers]);


  const data2 = filterUserData(data)

  const statusFilter = selectedStatus === "active" ? "0" : "1";

  const filteredData = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { RoleName: selectedStatus }
        : {};
    return filterData(
      data || [],
      filters,
      "CreatedAt",
      "CreatedAt",
      selectedSort
    );
  }, [totalUsers, selectedStatus, selectedSort, roleWiseUsers, selectedRoleId]);


  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [selectedStatus, selectedSort, roleWiseUsers]);

  const columns = [
    {
      title: "Name",
      dataIndex: "DisplayName",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          {/* <Link to="#" className="avatar avatar-md border avatar-rounded">
                        <ImageWithBasePath src={record.Image} className="img-fluid" alt="img" />
                    </Link> */}
          <div className="ms-2">
            <h6 className="fw-medium">
              <Link to="#">{text}</Link>
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) => a.DisplayName.length - b.DisplayName.length,
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: any, b: any) => a.Email.length - b.Email.length,
    },
    {
      title: "Created Date",
      dataIndex: "CreatedAt",
      sorter: (a: any, b: any) => new Date(a.CreatedAt).getTime() - new Date(b.CreatedAt).getTime(),
      render: (text: string) => text ? text.split("T")[0] : "",
    },
    {
      title: "Role",
      dataIndex: "RoleName",
      render: (text: String, record: any) => (
        <span
          className={`badge d-inline-flex align-items-center badge-xs ${text === "Employee" ? "badge-pink-transparent" : "badge-soft-purple"
            }`}
        >
          {text}
        </span>
      ),
      sorter: (a: any, b: any) => a.RoleName.length - b.RoleName.length,
    },
    {
      title: "Status",
      dataIndex: "IsActive", // Assuming your API sends `IsActive`
      render: (isActive: number, record: any) => {
        const statusText = isActive === 1 ? "Active" : "Inactive";
        return (
          <span
            className={`badge d-inline-flex align-items-center badge-xs ${statusText === "Active" ? "badge-success" : "badge-danger"
              }`}
          >
            <i className="ti ti-point-filled me-1" />
            {statusText}
          </span>
        );
      },
      sorter: (a: any, b: any) => a.IsActive - b.IsActive,
    },
  ];

  useEffect(() => {
    if (!Array.isArray(monthcount) || monthcount.length === 0 || !selectedYear) return;

    const updatedCounts = new Array(12).fill(0);

    monthcount.forEach(({ month, year, user_count }: any) => {
      if (Number(year) === Number(selectedYear) && month >= 1 && month <= 12) {
        updatedCounts[month - 1] = user_count;
      }
    });

    // Only update chart if data changed
    setuserchart((prev: any) => {
      const newSeries = {
        ...prev.series[0],
        data: updatedCounts,
      };

      return {
        ...prev,
        series: [newSeries],
      };
    });
  }, [monthcount, selectedYear]);




  const [userchart, setuserchart] = useState<any>({
    series: [
      {
        name: "User",
        data: new Array(12).fill(0),
      },
    ],
    chart: {
      type: "bar",
      height: 185,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val: any) {
          return val + " units";
        },
      },
    },
    colors: ["#00E396"],
  });

  if (showOnlyTable) {
    return (
        <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
    );
  }
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">User Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">HR</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    User Report
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(data2, "User_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(data2, "User_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            <div className="col-xl-6 d-flex">
              <div className="row flex-fill">
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <p className="fs-12 fw-medium mb-1 text-truncate">
                              Total Users
                            </p>
                            <h4>{count?.[0].total_user_count}</h4>
                          </div>
                        </div>
                        <div className="leave-report-icon">
                          <Link to="#">
                            <span className="p-2 border border-primary bg-transparent-primary rounded-3 d-flex align-items-center justify-content-center">
                              <i className="ti ti-user text-primary" />
                            </span>
                          </Link>
                        </div>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +20.01%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <p className="fs-12 fw-medium mb-1 text-truncate">
                              Active Users
                            </p>
                            <h4>{count?.[0].total_active_users}</h4>
                          </div>
                        </div>
                        <div className="leave-report-icon">
                          <Link to="#">
                            <span className="p-2 border border-success bg-transparent-success rounded-3 d-flex align-items-center justify-content-center">
                              <i className="ti ti-user-check text-success" />
                            </span>
                          </Link>
                        </div>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +17.02%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <p className="fs-12 fw-medium mb-1 text-truncate">
                              New Users
                            </p>
                            <h4>{count?.[0].total_new_users}</h4>
                          </div>
                        </div>
                        <div className="leave-report-icon">
                          <Link to="#">
                            <span className="p-2 border border-skyblue bg-transparent-skyblue rounded-3 d-flex align-items-center justify-content-center">
                              <i className="ti ti-user-up text-skyblue" />
                            </span>
                          </Link>
                        </div>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +10.01%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <p className="fs-12 fw-medium mb-1 text-truncate">
                              Inactive Users
                            </p>
                            <h4>{count?.[0].total_inactive_users}</h4>
                          </div>
                        </div>
                        <div className="leave-report-icon">
                          <Link to="#">
                            <span className="p-2 border border-danger bg-transparent-danger rounded-3 d-flex align-items-center justify-content-center">
                              <i className="ti ti-user-pause text-danger" />
                            </span>
                          </Link>
                        </div>
                      </div>
                      {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-danger fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    -10.01%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <div className="d-flex align-items-center ">
                      <span className="me-2">
                        <i className="ti ti-chart-bar text-danger" />
                      </span>
                      <h5>Users</h5>
                    </div>
                    <div className="d-flex align-items-center">
                      <p className="d-inline-flex align-items-center me-2 mb-0">
                        <i className="ti ti-square-filled fs-12 text-success me-2" />
                        Users Joined
                      </p>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedYear}
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-2">
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2025")}
                          >
                            2025
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2024")}
                          >
                            2024
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2023")}
                          >
                            2023
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body py-0">
                  <ReactApexChart
                    id="user-chart"
                    options={userchart}
                    series={userchart.series}
                    type="bar"
                    height={185}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Users List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">

                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                      : "Select Type"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("Admin")}
                        className="dropdown-item rounded-1"
                      >
                        Admin
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("Manager")}
                        className="dropdown-item rounded-1"
                      >
                        Manager
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("Employee")}
                        className="dropdown-item rounded-1"
                      >
                        Employee
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("HR")}
                        className="dropdown-item rounded-1"
                      >
                        HR
                      </Link>
                    </li>
                  </ul>
                </div>
                {/* <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                        selectedStatus.slice(1)
                      : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("active")}
                        className="dropdown-item rounded-1"
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("inactive")}
                        className="dropdown-item rounded-1"
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div> */}
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default UserReports;
